(function () {
  'use strict';

  function initConditionGrid(root) {
    var trigger = root.querySelector('[data-condition-grid-trigger]');
    var overlay = root.querySelector('[data-condition-grid-overlay]');
    var panel   = root.querySelector('.condition-grid__panel');
    var closeBtn;

    if (!trigger || !panel || !overlay) return;

    // Déplacer le panel et l'overlay directement dans le body
    document.body.appendChild(overlay);
    document.body.appendChild(panel);

    closeBtn = panel.querySelector('[data-condition-grid-close]');

    var lastFocused = null;

    function getFocusable() {
      return panel.querySelectorAll(
        'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
      );
    }

    function open() {
      lastFocused = document.activeElement;
      panel.hidden = false;
      panel.offsetHeight;
      panel.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.classList.add('condition-grid-lock');
      trigger.setAttribute('aria-expanded', 'true');
      var focusables = getFocusable();
      if (focusables.length) focusables[0].focus();
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      panel.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.classList.remove('condition-grid-lock');
      trigger.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKeydown);
      var onTransitionEnd = function () {
        panel.hidden = true;
        panel.removeEventListener('transitionend', onTransitionEnd);
      };
      panel.addEventListener('transitionend', onTransitionEnd);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    function onKeydown(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {
        var focusables = Array.prototype.slice.call(getFocusable());
        if (!focusables.length) return;
        var first = focusables[0];
        var last  = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      }
    }

    trigger.addEventListener('click', open);
    overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
  }

  function init() {
    document.querySelectorAll('[data-condition-grid]').forEach(initConditionGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

